<template>
  <a-collapse
    class="collapse-panel-box"
    :bordered="false"
    :activeKey="activeKey"
  >
    <template #expandIcon="props">
      <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
    </template>
    <a-collapse-panel
      class="collapse-info"
      key="1"
      :header="title"
      :style="customStyle"
    >
      <slot />
    </a-collapse-panel>
  </a-collapse>
</template>
<script>
export default {
  name: "CollapseTitle",
  props: ['title', 'customStyle', 'open'],
  data() {
    return {};
  },
  computed: {
    activeKey() {
      return this.open ? ['1'] : []
    }
  }
}
</script>
<style scoped>
.collapse-panel-box {
  background: transparent;
  margin: 6px 0 0;
}

.collapse-panel-box /deep/ .ant-collapse-header {
  padding: 2px 18px;
}

.collapse-panel-box .collapse-info {
  border: 0;
}

.collapse-panel-box /deep/ .ant-collapse-content-box {
  padding: 0 0 4px 18px;
}

.collapse-panel-box
  > .ant-collapse-item
  > .ant-collapse-header
  .ant-collapse-arrow {
  left: 0;
}

.collapse-panel-box
  /deep/
  > .ant-collapse-item
  > .ant-collapse-content
  > .ant-collapse-content-box {
  padding-top: 0;
}

.collapse-info /deep/ .label-slider .label {
  width: auto;
}

.collapse-info /deep/ .label-slider .setting-slider {
  width: 76px;
  margin-left: 8px;
  margin-right: 8px;
}
</style>